interface TermsProps {
  classes?: any
}

export const SignUpTerms: React.FC<TermsProps> = ({ classes }) => (
  <>
    <div id="terms">
      <h3 className={classes ? classes.termsSubHeading : ''}>
        Last updated July 29, 2021
      </h3>

      <h3 className={classes ? classes.termsSubHeading : ''}>
        AGREEMENT TO TERMS
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        These Terms of Use constitute a legally binding agreement made between
        you, whether personally or on behalf of an entity (“you”) and Labra
        Ventures (<strong>"Company"</strong>, <strong>“we”</strong>,{' '}
        <strong>“us”</strong>, or <strong>“our”</strong>), concerning your
        access to and use of the{' '}
        <a href="https://labra.io" target="_blank">
          https://labra.io
        </a>{' '}
        website as well as any other media form, media channel, mobile website
        or mobile application related, linked, or otherwise connected thereto
        (collectively, the “Site”). You agree that by accessing the Site, you
        have read, understood, and agree to be bound by all of these Terms of
        Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE
        EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE
        IMMEDIATELY.
      </p>

      <p className={classes ? classes.termsParagraph : ''}>
        Supplemental terms and conditions or documents that may be posted on the
        Site from time to time are hereby expressly incorporated herein by
        reference. We reserve the right, in our sole discretion, to make changes
        or modifications to these Terms of Use at any time and for any reason.
        We will alert you about any changes by updating the “Last updated” date
        of these Terms of Use, and you waive any right to receive specific
        notice of each such change. It is your responsibility to periodically
        review these Terms of Use to stay informed of updates. You will be
        subject to, and will be deemed to have been made aware of and to have
        accepted, the changes in any revised Terms of Use by your continued use
        of the Site after the date such revised Terms of Use are posted.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        The information provided on the Site is not intended for distribution to
        or use by any person or entity in any jurisdiction or country where such
        distribution or use would be contrary to law or regulation or which
        would subject us to any registration requirement within such
        jurisdiction or country. Accordingly, those persons who choose to access
        the Site from other locations do so on their own initiative and are
        solely responsible for compliance with local laws, if and to the extent
        local laws are applicable.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        The Site is not tailored to comply with industry-specific regulations
        (Health Insurance Portability and Accountability Act (HIPAA), Federal
        Information Security Management Act (FISMA), etc.), so if your
        interactions would be subjected to such laws, you may not use this Site.
        You may not use the Site in a way that would violate the
        Gramm-Leach-Bliley Act (GLBA).
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        The Site is intended for users who are at least 18 years old. Persons
        under the age of 18 are not permitted to use or register for the Site.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        INTELLECTUAL PROPERTY RIGHTS
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        Unless otherwise indicated, the Site is our proprietary property and all
        source code, databases, functionality, software, website designs, audio,
        video, text, photographs, and graphics on the Site (collectively, the
        “Content”) and the trademarks, service marks, and logos contained
        therein (the “Marks”) are owned or controlled by us or licensed to us,
        and are protected by copyright and trademark laws and various other
        intellectual property rights and unfair competition laws of the United
        States, international copyright laws, and international conventions. The
        Content and the Marks are provided on the Site “AS IS” for your
        information and personal use only. Except as expressly provided in these
        Terms of Use, no part of the Site and no Content or Marks may be copied,
        reproduced, aggregated, republished, uploaded, posted, publicly
        displayed, encoded, translated, transmitted, distributed, sold,
        licensed, or otherwise exploited for any commercial purpose whatsoever,
        without our express prior written permission.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        Provided that you are eligible to use the Site, you are granted a
        limited license to access and use the Site and to download or print a
        copy of any portion of the Content to which you have properly gained
        access solely for your personal, non-commercial use. We reserve all
        rights not expressly granted to you in and to the Site, the Content and
        the Marks.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        USER REPRESENTATIONS
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        By using the Site, you represent and warrant that: (1) all registration
        information you submit will be true, accurate, current, and complete;
        (2) you will maintain the accuracy of such information and promptly
        update such registration information as necessary; (3) you have the
        legal capacity and you agree to comply with these Terms of Use; (4) you
        are not a minor in the jurisdiction in which you reside; (5) you will
        not access the Site through automated or non-human means, whether
        through a bot, script or otherwise; (6) you will not use the Site for
        any illegal or unauthorized purpose; and (7) your use of the Site will
        not violate any applicable law or regulation.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        If you provide any information that is untrue, inaccurate, not current,
        or incomplete, we have the right to suspend or terminate your account
        and refuse any and all current or future use of the Site (or any portion
        thereof).
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        USER REGISTRATION
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        You may be required to register with the Site. You agree to keep your
        password confidential and will be responsible for all use of your
        account and password. We reserve the right to remove, reclaim, or change
        a username you select if we determine, in our sole discretion, that such
        username is inappropriate, obscene, or otherwise objectionable.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        FEES AND PAYMENT
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        We accept the following forms of payment:
      </p>
      <ul className={classes ? classes.termsParagraph : ''}>
        <li className={classes ? classes.termsParagraph : ''}>Visa</li>
        <li className={classes ? classes.termsParagraph : ''}>Mastercard</li>
        <li className={classes ? classes.termsParagraph : ''}>
          American Express
        </li>
        <li className={classes ? classes.termsParagraph : ''}>Discover</li>
        <li className={classes ? classes.termsParagraph : ''}>PayPal</li>
      </ul>
      <p className={classes ? classes.termsParagraph : ''}>
        You may be required to purchase or pay a fee to access some of our
        services. You agree to provide current, complete, and accurate purchase
        and account information for all purchases made via the Site. You further
        agree to promptly update account and payment information, including
        email address, payment method, and payment card expiration date, so that
        we can complete your transactions and contact you as needed. We bill you
        through an online billing account for purchases made via the Site. Sales
        tax will be added to the price of purchases as deemed required by us. We
        may change prices at any time. All payments shall be in U.S. dollars.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        You agree to pay all charges or fees at the prices then in effect for
        your purchases, and you authorize us to charge your chosen payment
        provider for any such amounts upon making your purchase. If your
        purchase is subject to recurring charges, then you consent to our
        charging your payment method on a recurring basis without requiring your
        prior approval for each recurring charge, until you notify us of your
        cancellation.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        We reserve the right to correct any errors or mistakes in pricing, even
        if we have already requested or received payment. We also reserve the
        right to refuse any order placed through the Site.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>CANCELLATION</h3>
      <p className={classes ? classes.termsParagraph : ''}>
        You can cancel your subscription at any time by contacting us using the
        contact information provided below. Your cancellation will take effect
        at the end of the current paid term.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        If you are unsatisfied with our services, please email us at
        support@labra.io or call us at (609) 436-9288.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        PROHIBITED ACTIVITIES
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        You may not access or use the Site for any purpose other than that for
        which we make the Site available. The Site may not be used in connection
        with any commercial endeavors except those that are specifically
        endorsed or approved by us.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        As a user of the Site, you agree not to:
      </p>
      <ol type="1" className={classes ? classes.termsParagraph : ''}>
        <li className={classes ? classes.termsParagraph : ''}>
          Make any unauthorized use of the Site, including collecting usernames
          and/or email addresses of users by electronic or other means for the
          purpose of sending unsolicited email, or creating user accounts by
          automated means or under false pretenses.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Use the Site to advertise or offer to sell goods and services.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Circumvent, disable, or otherwise interfere with security-related
          features of the Site, including features that prevent or restrict the
          use or copying of any Content or enforce limitations on the use of the
          Site and/or the Content contained therein.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Engage in unauthorized framing of or linking to the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Trick, defraud, or mislead us and other users, especially in any
          attempt to learn sensitive account information such as user passwords.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Make improper use of our support services or submit false reports of
          abuse or misconduct.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Use the Site in a manner inconsistent with any applicable laws or
          regulations.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Disparage, tarnish, or otherwise harm, in our opinion, us and/or the
          Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Except as may be the result of standard search engine or Internet
          browser usage, use, launch, develop, or distribute any automated
          system, including without limitation, any spider, robot, cheat
          utility, scraper, or offline reader that accesses the Site, or using
          or launching any unauthorized script or other software.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Upload or transmit (or attempt to upload or to transmit) any material
          that acts as a passive or active information collection or
          transmission mechanism, including without limitation, clear graphics
          interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other
          similar devices (sometimes referred to as “spyware” or “passive
          collection mechanisms” or “pcms”).
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Upload or transmit (or attempt to upload or to transmit) viruses,
          Trojan horses, or other material, including excessive use of capital
          letters and spamming (continuous posting of repetitive text), that
          interferes with any party’s uninterrupted use and enjoyment of the
          Site or modifies, impairs, disrupts, alters, or interferes with the
          use, features, functions, operation, or maintenance of the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Delete the copyright or other proprietary rights notice from any
          Content.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Copy or adapt the Site’s software, including but not limited to Flash,
          PHP, HTML, JavaScript, or other code.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Attempt to bypass any measures of the Site designed to prevent or
          restrict access to the Site, or any portion of the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Harass, annoy, intimidate, or threaten any of our employees or agents
          engaged in providing any portion of the Site to you.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Decipher, decompile, disassemble, or reverse engineer any of the
          software comprising or in any way making up a part of the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Use the Site as part of any effort to compete with us or otherwise use
          the Site and/or the Content for any revenue-generating endeavor or
          commercial enterprise.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Use any information obtained from the Site in order to harass, abuse,
          or harm another person.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Systematically retrieve data or other content from the Site to create
          or compile, directly or indirectly, a collection, compilation,
          database, or directory without written permission from us.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Use a buying agent or purchasing agent to make purchases on the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Engage in any automated use of the system, such as using scripts to
          send comments or messages, or using any data mining, robots, or
          similar data gathering and extraction tools.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Interfere with, disrupt, or create an undue burden on the Site or the
          networks or services connected to the Site.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Attempt to impersonate another user or person or use the username of
          another user.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Sell or otherwise transfer your profile.
        </li>
      </ol>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        USER GENERATED CONTRIBUTIONS
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        The Site does not offer users to submit or post content. We may provide
        you with the opportunity to create, submit, post, display, transmit,
        perform, publish, distribute, or broadcast content and materials to us
        or on the Site, including but not limited to text, writings, video,
        audio, photographs, graphics, comments, suggestions, or personal
        information or other material (collectively, "Contributions").
        Contributions may be viewable by other users of the Site and through
        third-party websites. As such, any Contributions you transmit may be
        treated in accordance with the Site Privacy Policy. When you create or
        make available any Contributions, you thereby represent and warrant
        that:
      </p>
      <ol type="1" className={classes ? classes.termsParagraph : ''}>
        <li className={classes ? classes.termsParagraph : ''}>
          The creation, distribution, transmission, public display, or
          performance, and the accessing, downloading, or copying of your
          Contributions do not and will not infringe the proprietary rights,
          including but not limited to the copyright, patent, trademark, trade
          secret, or moral rights of any third party.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          You are the creator and owner of or have the necessary licenses,
          rights, consents, releases, and permissions to use and to authorize
          us, the Site, and other users of the Site to use your Contributions in
          any manner contemplated by the Site and these Terms of Use.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          You have the written consent, release, and/or permission of each and
          every identifiable individual person in your Contributions to use the
          name or likeness of each and every such identifiable individual person
          to enable inclusion and use of your Contributions in any manner
          contemplated by the Site and these Terms of Use.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions are not false, inaccurate, or misleading.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions are not unsolicited or unauthorized advertising,
          promotional materials, pyramid schemes, chain letters, spam, mass
          mailings, or other forms of solicitation.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions are not obscene, lewd, lascivious, filthy, violent,
          harassing, libelous, slanderous, or otherwise objectionable (as
          determined by us).
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not ridicule, mock, disparage, intimidate, or
          abuse anyone.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions are not used to harass or threaten (in the legal
          sense of those terms) any other person and to promote violence against
          a specific person or class of people.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not violate any applicable law, regulation, or
          rule.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not violate the privacy or publicity rights of
          any third party.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not contain any material that solicits personal
          information from anyone under the age of 18 or exploits people under
          the age of 18 in a sexual or violent manner.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not violate any applicable law concerning child
          pornography, or otherwise intended to protect the health or well-being
          of minors.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not include any offensive comments that are
          connected to race, national origin, gender, sexual preference, or
          physical handicap.
        </li>
        <li className={classes ? classes.termsParagraph : ''}>
          Your Contributions do not otherwise violate, or link to material that
          violates, any provision of these Terms of Use, or any applicable law
          or regulation.
        </li>
      </ol>
      <p className={classes ? classes.termsParagraph : ''}>
        Any use of the Site in violation of the foregoing violates these Terms
        of Use and may result in, among other things, termination or suspension
        of your rights to use the Site.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        CONTRIBUTION LICENSE
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        You and the Site agree that we may access, store, process, and use any
        information and personal data that you provide following the terms of
        the Privacy Policy and your choices (including settings).
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        By submitting suggestions or other feedback regarding the Site, you
        agree that we can use and share such feedback for any purpose without
        compensation to you.
      </p>
      <p className={classes ? classes.termsParagraph : ''}>
        We do not assert any ownership over your Contributions. You retain full
        ownership of all of your Contributions and any intellectual property
        rights or other proprietary rights associated with your Contributions.
        We are not liable for any statements or representations in your
        Contributions provided by you in any area on the Site. You are solely
        responsible for your Contributions to the Site and you expressly agree
        to exonerate us from any and all responsibility and to refrain from any
        legal action against us regarding your Contributions.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>SUBMISSIONS</h3>
      <p className={classes ? classes.termsParagraph : ''}>
        You acknowledge and agree that any questions, comments, suggestions,
        ideas, feedback, or other information regarding the Site ("Submissions")
        provided by you to us are non-confidential and shall become our sole
        property. We shall own exclusive rights, including all intellectual
        property rights, and shall be entitled to the unrestricted use and
        dissemination of these Submissions for any lawful purpose, commercial or
        otherwise, without acknowledgment or compensation to you. You hereby
        waive all moral rights to any such Submissions, and you hereby warrant
        that any such Submissions are original with you or that you have the
        right to submit such Submissions. You agree there shall be no recourse
        against us for any alleged or actual infringement or misappropriation of
        any proprietary right in your Submissions.
      </p>
      <h3 className={classes ? classes.termsSubHeading : ''}>
        U.S. GOVERNMENT RIGHTS
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        Our services are “commercial items” as defined in Federal Acquisition
        Regulation (“FAR”) 2.101. If our services are acquired by or on behalf
        of any agency not within the Department of Defense (“DOD”), our services
        are subject to the terms of these Terms of Use in accordance with FAR
        12.212 (for computer software) and FAR 12.211 (for technical data). If
        our services are acquired by or on behalf of any agency within the
        Department of Defense, our services are subject to the terms of these
        Terms of Use in accordance with Defense Federal Acquisition Regulation
        (“DFARS”) 227.7202‑3. In addition, DFARS 252.227‑7015 applies to
        technical data acquired by the DOD. This U.S. Government Rights clause
        is in lieu of, and supersedes, any other FAR, DFARS, or other clause or
        provision that addresses government rights in computer software or
        technical data under these Terms of Use.
      </p>

      <h3 className={classes ? classes.termsSubHeading : ''}>
        SITE MANAGEMENT
      </h3>
      <p className={classes ? classes.termsParagraph : ''}>
        We reserve the right, but not the obligation, to: (1) monitor the Site
        for violations of these Terms of Use; (2) take appropriate legal action
        against anyone who, in our sole discretion, violates the law or these
        Terms of Use, including without limitation, reporting such user to law
        enforcement authorities; (3) in our sole discretion and without
        limitation, refuse, restrict access to, limit the availability of, or
        disable (to the extent technologically feasible) any of your
        Contributions or any portion thereof; (4) in our sole discretion and
        without limitation, notice, or liability, to remove from the Site or
        otherwise disable all files and content that are excessive in size or
        are in any way burdensome to our systems; and (5) otherwise manage the
        Site in a manner designed to protect our rights and property and to
        facilitate the proper functioning of the Site.
      </p>
    </div>
  </>
)
